import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { exchangeAuthSession, getCreatorId } from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setError("Missing session_id in callback URL");
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const guest = getCreatorId();
        const res = await exchangeAuthSession(session_id, guest);
        // Clear the fragment from history
        window.history.replaceState({}, document.title, window.location.pathname);
        await refresh();
        const migrated = res?.migration?.migrated || {};
        const migratedCount = Object.values(migrated).reduce((a, b) => a + Number(b || 0), 0);
        if (migratedCount > 0) {
          toast.success(`Welcome back — migrated ${migratedCount} guest item(s) to your account`);
        } else {
          toast.success(`Signed in as ${res.user.name || res.user.email}`);
        }
        navigate("/", { replace: true });
      } catch (err) {
        window.history.replaceState({}, document.title, window.location.pathname);
        setError(err?.response?.data?.detail || err?.message || "Sign-in failed");
      }
    })();
  }, [location, navigate, refresh]);

  if (error) {
    return (
      <div className="mx-auto max-w-[900px] px-6 py-24 md:px-10 text-center">
        <h1 className="font-display text-5xl uppercase text-white">Sign-in failed</h1>
        <p className="mt-3 text-neutral-400">{error}</p>
        <a href="/" className="mt-6 inline-block border border-white/20 px-4 py-2 font-mono text-[11px] uppercase tracking-widest text-white hover:bg-white hover:text-black">
          Back to home
        </a>
      </div>
    );
  }

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3">
      <Loader2 className="h-6 w-6 animate-spin text-[#FF3B30]" />
      <p className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">Completing sign-in...</p>
    </div>
  );
}
